import * as PIXI from "pixi.js-legacy";
import { EASE, getTweenAsync } from "../../framework/src/modules/Tween";
import { Frames } from "../Code/Frames";

export default class BaseAnimSprite extends PIXI.AnimatedSprite{

    constructor(texturesName:string , animationSpeed: number = 0.333 , position?: {x:number, y:number} ){
        super(Frames[texturesName]);

        if (position != undefined){
            this.position.set(position.x,position.y);
        }
        this.alpha = 0; 
        this.anchor.set(0.5,0.5);
        this.name = texturesName;
        this.animationSpeed = animationSpeed;
        this.loop = false;
        this.visible = false;          
    }

    async animate() {
        return new Promise<void>(async (res) => {
            this.onComplete = async () => {                
                this.stop();
                res();
            };

            this.alpha = 1;
            this.visible = true;                   
            this.play();
        });
    }

    resetAnimation(){
        this.alpha = 0;
        this.gotoAndStop(0);
        this.visible = false;
    }

    clearAnimation(){
        this.alpha = 0;
        this.stop();
        this.visible = false;       
        this.destroy({children:true, baseTexture:true});
    }
}